export const DEFAULT_SUBHEADING_TEXT =
  "The Wall Street Journal’s Future of Everything Festival brings together the most revolutionary minds to explore the ideas forming what comes next.";
export const DEFAULT_BUTTON_TEXT = "Register";
